import styled from "../../styled";

export const OrderNumber = styled("div")`
  font-family: ${({theme}) => theme.font.header};
  background: ${({theme}) => theme.colors.primary};
  color: ${({theme}) => theme.colors.primary_text};
  font-size: 18px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 30px;
`;
